/* unplugin-vue-components disabled */import { render } from "./video-detail.vue?vue&type=template&id=eefa3b0c&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"

import "./video-detail.vue?vue&type=style&index=0&id=eefa3b0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefa3b0c"]])

export default __exports__